/* istanbul ignore file */
import { oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { DeletionType } from './DeletionType';
import { FileRule } from './FileRule';
const FileDeletionParser = /* #__PURE__ */ parsers.object([
    ['fullname', codecString],
    ['reason', /* #__PURE__ */ codecOneOf([FileRule, codecString])],
    ['deletionType', DeletionType, 'deletion_type'],
    ['name', codecString],
]);
export class FileDeletion extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FileDeletionParser.decode(input).map(res => new FileDeletion(res));
    }
    static unsafeDecode(input) {
        return FileDeletion.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FileDeletionParser.encode(data);
    }
    static schema() {
        return FileDeletionParser.schema();
    }
}
